module.exports = __webpack_public_path__ + "static/media/JP.4187b1d4.svg";